var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2536_104853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49479 16.8081C3.85071 16.8081 0.0859375 13.0455 0.0859375 8.40404C0.0859375 3.76262 3.85071 0 8.49479 0C13.1389 0 16.9036 3.76262 16.9036 8.40404C16.8985 13.0434 13.1368 16.803 8.49479 16.8081ZM7.64935 7.55551C7.18286 7.55536 6.80461 7.93528 6.80461 8.40177C6.80461 8.86618 7.18108 9.24444 7.64549 9.24444V11.6061C7.64549 12.1583 8.09321 12.6061 8.64549 12.6061H9.34456C9.8087 12.6061 10.185 12.2298 10.185 11.7657C10.185 11.3015 9.8087 10.9253 9.34456 10.9253H9.33567L9.34158 8.55824C9.34296 8.00511 8.89504 7.55592 8.34191 7.55574L7.64935 7.55551ZM8.49479 4.20202C8.02623 4.20202 7.64549 4.58186 7.64549 5.05041C7.64549 5.51896 8.02623 5.8988 8.49479 5.8988C8.96334 5.8988 9.34408 5.51896 9.34408 5.05041C9.34408 4.58186 8.96334 4.20202 8.49479 4.20202Z",
    fill: "#AFBBCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2536_104853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8177,
    height: 16.8081,
    fill: "white",
    transform: "translate(0.0859375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleIcon);
export default __webpack_public_path__ + "static/media/info-circle-icon.cccb5a918ca84b6a34859ec89eb9fb60.svg";
export { ForwardRef as ReactComponent };